import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { VoucherIcon } from 'components/Atoms/Icon';
import { USER_ROLES } from 'constants/common';

const AllocationManagement = lazy(() =>
  import('modules/allocation/Allocation')
);
const AllocationEditScreen = lazy(() =>
  import('modules/allocation/Allocation/components/AllocationEditScreen')
);

export const allocationRoutes = [
  // {
  //   path: routePath.ALLOCATION,
  //   component: AllocationManagement,
  //   exact: true,
  //   name: routeName.ALLOCATION,
  //   showMenu: true,
  //   icon: VoucherIcon,
  //   roles: [USER_ROLES.ADMIN],
  //   breadcrumbs: [{ name: routeName.ALLOCATION }],
  // },
  {
    path: routePath.EDIT_ALLOCATION,
    component: AllocationEditScreen,
    name: routeName.EDIT_ALLOCATION,
    showMenu: false,
    icon: VoucherIcon,
  },
];
